var map = {
	"./MingChang.png": 130,
	"./MingChang2.png": 58346,
	"./SWJTU.png": 30845,
	"./coal-white.png": 77779,
	"./coal.png": 46611,
	"./coal2.png": 72937,
	"./logo/MingChang.png": 56704,
	"./logo/MingChang2.png": 23504,
	"./pb-name.png": 3158,
	"./pb.png": 98248,
	"./thu-wz-white.png": 98931,
	"./thu-wz.png": 60755,
	"./thu.png": 25633
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40233;